"use client";
import Script from "next/script";
import { instagramEmbedUrl } from "@/lib/instagram";

export function InstagramCard({ url, title }: { url: string; title: string }) {
  const embed = instagramEmbedUrl(url);
  if (!url) return <p className="muted">Instagram de esta obra pendiente.</p>;
  function process() {
    (
      window as unknown as { instgrm?: { Embeds: { process(): void } } }
    ).instgrm?.Embeds.process();
  }
  return (
    <div className="instagram-card">
      <a href={url} target="_blank" rel="noopener noreferrer">
        Ver {title} en Instagram ↗
      </a>
      {embed && (
        <>
          <blockquote
            className="instagram-media"
            data-instgrm-permalink={embed}
            data-instgrm-version="14"
          >
            <a href={url} target="_blank" rel="noopener noreferrer">
              Abrir en Instagram
            </a>
          </blockquote>
          <Script
            src="https://www.instagram.com/embed.js"
            strategy="afterInteractive"
            onReady={process}
          />
          <p className="muted">
            Si el contenido no carga, abrilo en Instagram. La compra sigue
            disponible.
          </p>
        </>
      )}
    </div>
  );
}
